import React from "react";
import LegalMarkdown from "../components/LegalMarkdown";

export default function Privacy() {
  return <LegalMarkdown src={`${process.env.PUBLIC_URL}/privacy.md`} />;
}
